import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from "react";
import EnterLeaveGroup from "./EnterLeaveGroup";

var OnOff = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OnOff, _React$Component);

  function OnOff() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = OnOff.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        keyAndData = _this$props.keyAndData,
        registerNode = _this$props.registerNode,
        enterPositionStyle = _this$props.enterPositionStyle,
        enterDecorationStyle = _this$props.enterDecorationStyle,
        leaveStyle = _this$props.leaveStyle;
    return React.createElement(EnterLeaveGroup, {
      registerNode: registerNode,
      keysAndData: keyAndData ? [keyAndData] : [],
      enterPositionStyle: enterPositionStyle,
      enterDecorationStyle: enterDecorationStyle,
      leaveStyle: leaveStyle
    }, function (keysAndData, registerEnterLeave) {
      return keysAndData.length ? children(keysAndData[0].key, keysAndData[0].data, registerEnterLeave) : children(null, null, registerEnterLeave);
    });
  };

  return OnOff;
}(React.Component);

export { OnOff as default };
process.env.NODE_ENV !== "production" ? void 0 : void 0;